var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-app-bar',{staticStyle:{"background":"#5CB1F9"},attrs:{"app":"","dark":"","flat":""}},[_c('div',{staticClass:"d-flex align-center font-weight-bold "},[_vm._v(" 大学生のための時間割 ")])]),_c('v-content',[_c('Home')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }